module.exports = __webpack_public_path__ + "img/C15.74fc86ed.png";